"use client";

import React, { useEffect, useRef, useState } from "react";
import "./Personal_Info.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";

import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import Green_round_btn from "../../../common-components/common_btn/green_round_btn/Green_round_btn";
import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
import Address_Modal from "../../../common-components/common_modal/address-modal/Address_Modal";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
import Logout_Modal from "../../../common-components/common_modal/logout_modal/Logout_Modal";

import {
  myAccount,
  myaccountUpdate,
} from "../../../../features/my_account/Slice";

import { RegxExpression } from "../../../../utils/common";
import {
  getAllOrderAddress,
  getSingleOrderAddress,
} from "../../../../features/order/orderSlice";
import { deleteUserAddress } from "../../../../features/user/userSlice";
import Delete_Modal from "./delete_popup/Delete_Modal";
import ChangeEmail_Modal from "./change_email_popup/ChangeEmail_Modal";

const Personal_Info = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [showAccountCreated, setShowAccountCreated] = useState(false);
  const [showAccountDeleted, setShowAccountDeleted] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [deleteAddressId, setDeleteAddressId] = useState(null);

  const dispatch = useDispatch();

  const user = useSelector((state) => state.myaccount?.addMyaccount);

  const fileInputRef = useRef(null);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      last_name: "",
      email: "",
      password: "",
      contact_no: "",
      dob: "",
      gender_id: "",
    },
  });

  useEffect(() => {
    dispatch(myAccount());
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      reset({
        name: user?.name || "",
        last_name: user?.last_name || "",
        email: user?.email || "",
        password: "",
        contact_no: user?.contact_no || "",
        dob: user?.dob || "",
        gender_id: user?.gender_id ? String(user.gender_id) : "",
      });
    }
  }, [user, reset]);

  const [previewImage, setPreviewImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      setSelectedFile(file);

      const imageUrl = URL.createObjectURL(file);

      setPreviewImage(imageUrl);
    }
  };

  const onSubmit = async (data) => {
    const DataToSend = new FormData();
    DataToSend.append("contact_no", data?.contact_no);
    DataToSend.append("name", data?.name);
    if (selectedFile) {
      DataToSend.append("image", selectedFile);
    }

    const res = await dispatch(myaccountUpdate(DataToSend));

    if (res?.meta?.requestStatus === "fulfilled") {
      setShowAccountCreated(true);
      setTimeout(() => {
        setShowAccountCreated(false);
      }, 3000);

      await dispatch(myAccount());

      setIsEdit(false);
    }

    if (res?.meta?.requestStatus === "rejected") {
      if (res?.payload?.data?.errors?.email) {
        setError("email", {
          type: "manual",
          message: res.payload.data.errors.email,
        });
      }

      if (res?.payload?.data?.errors?.contact_no) {
        setError("contact_no", {
          type: "manual",
          message: res.payload.data.errors.contact_no,
        });
      }
    }
  };

  // =========================
  // USER INITIALS
  // =========================
  const getInitials = (firstName = "", lastName = "") => {
    const firstInitial = firstName?.charAt(0) || "";
    const lastInitial = lastName?.charAt(0) || "";

    return `${firstInitial}${lastInitial}`.toUpperCase();
  };

  const [id, setId] = useState();
  const [isUpdate, setIsUpdate] = useState(false);

  const handleEdit = async (data) => {
    setId(data.id);
    setIsUpdate(true);
    setShowAddressModal(true);
  };

  const allAddress = useSelector((state) => state.order.allOrdersAddress);

  // const handleDelete = async (id) => {
  //   await dispatch(deleteUserAddress(id));
  //   await dispatch(getAllOrderAddress());
  // };
  //   const handleDelete = async (id) => {
  //   const res = await dispatch(deleteUserAddress(id));

  //   if (res?.meta?.requestStatus === "fulfilled") {
  //     await dispatch(getAllOrderAddress());

  //     setShowAccountDeleted(true);

  //     setTimeout(() => {
  //       setShowAccountDeleted(false);
  //     }, 3000);
  //   }
  // };

  const handleDelete = (id) => {
    setDeleteAddressId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!deleteAddressId) return;

    const res = await dispatch(deleteUserAddress(deleteAddressId));

    if (res?.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllOrderAddress());

      setShowDeleteModal(false);
      setDeleteAddressId(null);

      setShowAccountDeleted(true);

      setTimeout(() => {
        setShowAccountDeleted(false);
      }, 3000);
    }
  };

  useEffect(() => {
    dispatch(getAllOrderAddress());
  }, []);

  const handleEmailChanged = async () => {
    setShowEmailModal(false);
    await dispatch(myAccount());
    setShowAccountCreated(true);
    setTimeout(() => {
      setShowAccountCreated(false);
    }, 3000);
  };

  return (
    <>
      <section className="Personal_Info_tab">
        <div className="top_div">
          {/* <div className="user_img_div">
            {user?.image ? (
              <img src={user?.image} alt="User" className="user_img" />
            ) : (
              <div className="initials_box">
                {getInitials(user?.name, user?.last_name)}
              </div>
            )}
          </div> */}
          <div className="user_img_div">
            {previewImage || user?.image ? (
              <img
                src={
                  previewImage
                    ? previewImage
                    : `${process.env.REACT_APP_IMG_URL}${user?.image}`
                }
                alt="User"
                className="user_img"
              />
            ) : (
              <div className="initials_box">
                {getInitials(user?.name, user?.last_name)}
              </div>
            )}
          </div>

          {isEdit && (
            <div onClick={handleUploadClick}>
              <Green_btn btnText="Upload Photo" />
            </div>
          )}

          <input
            type="file"
            ref={fileInputRef}
            hidden
            accept="image/*"
            onChange={handleFileChange}
          />
        </div>

        <div className="personal_info_form">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <p className="heading-text mb-0">Personal Info</p>

            {!isEdit && (
              <div
                className="edit-profile"
                onClick={() => {
                  setIsEdit(true);
                }}
              >
                <FontAwesomeIcon icon={faPenToSquare} />
              </div>
            )}

            {isEdit && (
              <div className="btns_holder">
                <div className="save_btn">
                  <Green_round_btn
                    btnText="Save"
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>

                <div className="cancel_btn">
                  <Green_round_btn
                    btnText="Cancel"
                    onClick={() => {
                      setIsEdit(false);

                      reset();
                    }}
                  />
                </div>
              </div>
            )}
          </div>

          <Form>
            <div className="row">
              <div className="col-sm-6">
                <Form.Group className="input_group ">
                  <Form.Label>Full Name</Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Enter Full Name"
                    readOnly={!isEdit}
                    {...register("name", {
                      required: "Full Name is required",
                    })}
                  />

                  {errors?.name && (
                    <sup className="text-danger">{errors?.name?.message}</sup>
                  )}
                </Form.Group>
              </div>

              <div className="col-sm-6">
                <Form.Group className="input_group ">
                  <Form.Label>Phone Number</Form.Label>

                  <Form.Control
                    readOnly={!isEdit}
                    type="text"
                    placeholder="Enter mobile number"
                    {...register("contact_no", {
                      required: "Mobile Number is required",
                      minLength: {
                        value: 10,
                        message: "Mobile number must be 10 digits",
                      },
                      maxLength: {
                        value: 10,
                        message: "Mobile number must be 10 digits",
                      },
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Mobile number must be 10 digits",
                      },
                    })}
                    maxLength={10}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault(); // Block non-numeric input
                      }
                    }}
                  />
                  {errors?.contact_no && (
                    <sup className="text-danger">
                      {errors?.contact_no?.message}
                    </sup>
                  )}
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <Form.Group className="input_group">
                  <Form.Label>Email ID</Form.Label>

                  <Form.Control
                    readOnly
                    disabled
                    type="text"
                    placeholder="Enter your email"
                    {...register("email")}
                  />
                  <span
                    className="change_email_text"
                    onClick={() => setShowEmailModal(true)}
                  >
                    Change Email
                  </span>
                </Form.Group>
              </div>
            </div>

            {/* <div className="row">
              <div className="col-md-12">
                <Form.Group className="input_group">
                  <Form.Label>Password</Form.Label>

                  <Form.Control
                    type="password"
                    readOnly={!isEdit}
                    value={
                      isEdit ? getValues("password") || "" : "************"
                    }
                    placeholder="Enter Password"
                    {...(isEdit
                      ? register("password", {
                          minLength: {
                            value: 6,
                            message: "Minimum 6 characters",
                          },
                        })
                      : {})}
                  />

                  {errors?.password && (
                    <sup className="text-danger">
                      {errors?.password?.message}
                    </sup>
                  )}
                </Form.Group>
              </div>
            </div> */}

            {/* <div className="row">
              <div className="col-sm-6">
                <Form.Group className="input_group">
                  <Form.Label>Date Of Birth</Form.Label>

                  <Form.Control
                    type="date"
                    readOnly={!isEdit}
                    {...register("dob", {
                      required: "DOB is required",
                    })}
                  />

                  {errors?.dob && (
                    <sup className="text-danger">{errors?.dob?.message}</sup>
                  )}
                </Form.Group>
              </div>
            </div> */}

            {/* ADDRESS */}

            <div className="address_section">
              <p className="address_title">Address</p>

              <div className="row mb-3">
                {allAddress?.data?.map((val, index) => {
                  const parts = [
                    val?.building,
                    val?.street,
                    val?.apartment,
                    val?.Users_Address_Detail?.Country?.name,
                    val?.Users_Address_Detail?.State?.name,
                    val?.Users_Address_Detail?.City?.name,
                    val?.Users_Address_Detail?.Pincode?.name,
                  ];
                  const fullAddress = parts.filter(Boolean).join(", ");
                  return (
                    <div className="col-lg-6 mb-3" key={val.id || index}>
                      <div className="address_card">
                        <div className="icons_holder">
                          <div className="edit_div">
                            <FontAwesomeIcon
                              icon={faPenToSquare}
                              className="edit_icon"
                              onClick={() => {
                                handleEdit(val);
                              }}
                            />
                          </div>
                          <div
                            className="edit_div"
                            onClick={() => {
                              handleDelete(val.id);
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              className="edit_icon"
                            />
                          </div>
                        </div>

                        <div className="address_row">
                          <span className="label">{fullAddress}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}

                <div className="col-lg-6 mb-3 add-adress-wrappper">
                  <div className="add_address_card">
                    <span
                      className="add_address_text"
                      onClick={() => setShowAddressModal(true)}
                    >
                      Add New Address
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* BUTTONS */}
          </Form>
        </div>

        {/* LOGOUT */}

        <div className="logout_btn">
          <Green_btn
            btnText="Log Out"
            onClick={() => setShowLogoutModal(true)}
          />
        </div>
      </section>

      {/* SUCCESS MODAL */}

      <Success_Modal
        show={showAccountCreated}
        onHide={() => setShowAccountCreated(false)}
        successText="Information Saved Successfully!"
      />

      <Success_Modal
        show={showAccountDeleted}
        onHide={() => setShowAccountDeleted(false)}
        successText="Information Deleted Successfully!"
      />

      {/* ADDRESS MODAL */}

      {/* <Address_Modal
        id={id}
        isUpdate={isUpdate}
        show={showAddressModal}
        onHide={() => {
          setIsUpdate(false);
          setId(null);
          setShowAddressModal(false);
        }}
      /> */}
      <Address_Modal
        id={id}
        isUpdate={isUpdate}
        show={showAddressModal}
        onHide={() => {
          setIsUpdate(false);
          setId(null);
          setShowAddressModal(false);
        }}
        onSuccess={() => {
          setShowAddressModal(false);
          setIsUpdate(false);
          setId(null);

          setShowAccountCreated(true);

          setTimeout(() => {
            setShowAccountCreated(false);
          }, 3000);

          dispatch(getAllOrderAddress());
        }}
      />

      {/* CHANGE EMAIL MODAL */}

      <ChangeEmail_Modal
        show={showEmailModal}
        currentEmail={user?.email}
        onHide={() => setShowEmailModal(false)}
        onSuccess={handleEmailChanged}
      />

      {/* LOGOUT MODAL */}

      <Logout_Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
      />

      <Delete_Modal
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
          setDeleteAddressId(null);
        }}
        onConfirm={confirmDelete}
      />
    </>
  );
};

export default Personal_Info;
